export const lettersList = "SA_LETTERS_LIST";